// removed by extract-text-webpack-plugin
module.exports = {"icon":"_2LkYp","iconWrapper":"JLZvF","iconClose":"_3BGIl _2LkYp","iconCloseWrapper":"_1JHyv JLZvF","iconPrev":"_1bNu_ _2LkYp","iconNext":"_2BMP4 _2LkYp"};